import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'

import Icon from '../../../../../../components/UI/Icon'
import UpcomingClassLanguage from '../../../../Statistic/UpcomingClassLanguage'
import JobsPostActionsInfo from './JobsPostActionsInfo'
import { Checkbox } from '../../../../../../components/UI'

import { selectRole } from '../../../../../../routing/fetchingfunction/user/user.reducer'
import { deleteJob } from '../../../../../../routing/fetchingfunction/job/job.actions'

import { getUserName } from '../../../../../../helpers'

import { imagePrefix, priceTypes } from '../../../../../../constants'

const JobsPost = ({
  jobPost,
  onDetails,
  onActivate,
  onDeactivate,
  onPromote,
  onCancelPromote,
  onRenewal,
  onCancelRenewal,
}) => {
  const dispatch = useDispatch()

  const role = useSelector(selectRole)

  // TODO
  const [isActive, setIsActive] = useState(false)
  const [isPromoted, setIsPromoted] = useState(false)
  const [isRenewal, setIsRenewal] = useState(false)

  const [isDeleteLoading, setIsDeleteLoading] = useState(false)

  const priceType = priceTypes.find((priceType) => jobPost.price_type === priceType.value)

  const handleToggleActive = () => {
    // TODO
    if (isActive) {
      setIsActive(false)
      onDeactivate(jobPost)
    } else {
      setIsActive(true)
      onActivate(jobPost)
    }
  }

  const handleDelete = () => {
    setIsDeleteLoading(true)

    dispatch(deleteJob(jobPost.job_hash)).then(() => {
      setIsDeleteLoading(false)
    })
  }

  const handlePromote = () => {
    // TODO
    if (isPromoted) {
      setIsPromoted(false)
      onCancelPromote(jobPost)
    } else {
      setIsPromoted(true)
      onPromote(jobPost)
    }
  }

  const handleRenewal = () => {
    // TODO
    if (isRenewal) {
      setIsRenewal(false)
      onCancelRenewal(jobPost)
    } else {
      setIsRenewal(true)
      onRenewal(jobPost)
    }
  }

  const handleDetails = () => {
    onDetails(jobPost.job_hash)
  }

  const languagesContent = jobPost.creator_profile.languages.map((language) => {
    return <UpcomingClassLanguage key={language} language={language} />
  })

  return (
    <div className="w-full bg-[#FEEBDD] rounded-[10px] flex flex-col items-center p-[10px] border-[#F79009] border-[1px]">
      <div className="w-full flex items-center">
        <div className="relative w-[220px] h-[294px]">
          {isPromoted && (
            <div className="absolute top-[8px] left-[8px] z-[1] px-[8px] py-[6px] rounded-[8px] bg-primary-button flex items-center justify-center">
              <Icon name="marketing" color="#FDFDFD" className="w-[16px] h-[16px] mr-[4px]" />

              <span className="text-xs text-[#FDFDFD] font-bold">Promoted</span>
            </div>
          )}

          <img
            src={`${imagePrefix}${jobPost.cover_image || jobPost.images[0]?.original || ''}`}
            alt={jobPost.job_title}
            className="w-full h-full rounded-[6px]"
          />
        </div>

        <div className="min-h-[294px] flex flex-col items-start bg-[#fff5ee] border-[#ffca84] border-[1px] rounded-[6px] ml-[10px] flex-1 p-[20px]">
          <div className="w-full flex items-start pb-[10px] border-b-[#F9E0CD] border-b-[1px]">
            <div className="flex-1 flex items-start flex-col">
              <h5 className="text-base text-primary-100 font-semibold mb-[4px]">
                {jobPost.job_category.name}
              </h5>

              <h6
                className="text-[20px] leading-[24px] font-bold text-primary-100"
                onClick={handleDetails}
              >
                {jobPost.job_title}
              </h6>

              <p className="text-lg font-bold text-primary-100 mt-[4px]" onClick={handleDetails}>
                {jobPost.post_title}
              </p>
            </div>

            <div className="ml-[8px] flex flex-col justify-center items-end">
              <div className="flex items-center">
                <img
                  src="/assets/icon/euro-coin.svg"
                  className="w-[24px] h-[24px]"
                  alt="Euro coin"
                />

                <span className="ml-[8px] text-base font-bold text-primary-100">
                  € {jobPost.price}
                </span>
              </div>

              <span className="mt-[4px] rounded-[8px] bg-primary-button h-[28px] px-[8px] text-sm text-white font-bold flex items-center">
                {priceType?.label} Job
              </span>
            </div>
          </div>

          <div className="w-full flex items-start flex-col mt-[16px]">
            <div className="w-full flex items-end justify-between">
              <span className="text-[18px] font-bold text-primary-100">
                {getUserName(
                  jobPost.job_creator,
                  jobPost.creator_profile.display_name,
                  jobPost.creator_profile.display_last_name
                )}
              </span>

              <div className="gap-x-[16px] flex items-center">
                <div className="flex justify-center items-center">
                  <img
                    className="w-[24px] h-[24px]"
                    src="/assets/icon/checkbox-multiple-line.svg"
                    alt="Checkbox"
                  />

                  <span className="font-normal ml-1 text-sm text-[#F67443]">
                    {jobPost.tutor_stats?.total_bookings || 0}
                  </span>
                </div>

                <div className="flex justify-center items-center">
                  <img className="w-[24px] h-[24px]" src="/assets/icon/user-green.svg" alt="User" />

                  <span className="font-normal ml-1 text-sm text-[#F67443]">
                    {jobPost.tutor_stats?.total_students || 0}
                  </span>
                </div>

                <div className="flex justify-center items-center">
                  <img className="w-[24x] h-[24px]" src="/assets/icon/star.svg" alt="Star" />

                  <span className="font-normal ml-1 text-sm text-[#F67443]">
                    {jobPost.tutor_stats?.overall_rating_average || 0}
                  </span>
                </div>
              </div>
            </div>

            <div className="w-full flex items-start mt-[10px]">
              <p className="flex-1 text-primary-100 text-sm font-normal line-clamp-4">
                {jobPost.description}
              </p>

              <button
                className="ml-[12px] rounded-[8px] h-[32px] shadow-button border-primary-button border-[1px] w-[200px] bg-white flex items-center justify-center text-sm font-semibold text-primary-button transition-colors duration-200 ease hover:!text-white hover:!bg-primary-button"
                onClick={handleDetails}
              >
                Contact Details
              </button>
            </div>
          </div>

          <div className="w-full flex items-center justify-between mt-[16px]">
            <div className="flex items-center">
              <img src="/assets/icon/lang.svg" alt="Language" className="mr-[8px]" />

              <ul className="flex items-center gap-x-[4px]">{languagesContent}</ul>
            </div>

            <div className="flex items-center justify-center gap-x-[24px]">
              <div className="flex items-center justify-center">
                <Icon className="mr-[4px]" name="global-line" color="#F79009" />

                <img className="block" src="/assets/image/America_Flag.svg" alt="us" />
              </div>

              <div className="flex items-center justify-center">
                <Icon className="mr-[4px]" name="home" color="#F79009" />

                <img className="block" src="/assets/image/Canada_Flag.svg" alt="us" />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="mt-[10px] w-full flex items-center">
        {/* TODO */}
        <button
          className={`h-[40px] px-[16px] shadow-button rounded-[8px] border-[1px] text-sm font-semibold transition-colors duration-200 ease ${isActive ? 'border-[#F79009] bg-[#FDFDFD] text-[#F79009] hover:text-white hover:bg-[#F79009]' : 'border-transparent text-white bg-[#1AC057] hover:bg-[#117b38]'}`}
          onClick={handleToggleActive}
        >
          {isActive ? 'Deactivate' : 'Activate'}
        </button>

        {/* TODO */}
        <label className="ml-[10px] cursor-pointer h-[40px] px-[16px] border-[#FF9053] border-[1px] shadow-button bg-[#FDFDFD] rounded-[8px] flex items-center">
          <Checkbox
            label="Promote"
            labelClassName="text-sm font-semibold text-primary-100"
            checked={isPromoted}
            onChange={handlePromote}
          />
        </label>

        {/* TODO */}
        <label className="ml-[10px] cursor-pointer h-[40px] px-[16px] border-[#FF9053] border-[1px] shadow-button bg-[#FDFDFD] rounded-[8px] flex items-center">
          <Checkbox
            label="Renewal"
            labelClassName="text-sm font-semibold text-primary-100"
            checked={isRenewal}
            onChange={handleRenewal}
          />
        </label>

        <JobsPostActionsInfo />

        <Link
          to={`/${role}/settings/my-banners/jobs-posts/edit/${jobPost.job_hash}`}
          className="group/edit ml-auto border-[#F67443] border-[1px] bg-[#FDFDFD] rounded-[6px] h-[40px] pl-[7px] pr-[16px] flex items-center hover:bg-[#F67443] transition-colors duration-200 ease"
        >
          <Icon
            name="edit-line"
            className="w-[16px] h-[16px] mr-[6px] text-[#F79009] group-hover/edit:text-white transition-colors duration-200 ease"
          />

          <span className="group-hover/edit:text-white text-primary-100 text-sm font-medium transition-colors duration-200 ease">
            Edit
          </span>
        </Link>

        <button
          disabled={isDeleteLoading}
          className={`ml-[10px] bg-[#EF4343] rounded-[6px] h-[40px] px-[16px] flex items-center hover:bg-[#ae0f0f] transition-all duration-200 ease ${isDeleteLoading ? 'opacity-70' : 'opacity-100'}`}
          onClick={handleDelete}
        >
          <Icon name="delete-bin-line" className="w-[24px] h-[24px] mr-[8px] text-white" />

          <span className="text-white text-sm font-medium">Delete</span>
        </button>
      </div>
    </div>
  )
}

export default JobsPost
